import { ChangeDetectorRef, Component, forwardRef, Host, Inject, Input, OnChanges, SimpleChanges } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { MenuAccordionComponent } from '../menu-accordion/menu-accordion.component';
import { ContainerBase } from '../../../core/base/container-base';
import { Router } from '@angular/router';
import chaining from '../../../core/helpers/chaining';
import * as _ from 'lodash'
import { Store } from '@ngrx/store';
import * as fromCatalog from '../../../catalog/reducers'
import * as product from '../../../catalog/actions/product'

@Component({
  selector: 'app-menu-accordion-group',
  templateUrl: './menu-accordion-group.component.html',
  styleUrls: ['./menu-accordion-group.component.scss'],
  animations: [
    trigger('slide', [
      state('down' , style({ height: '*', display: 'block' })),
      state('up', style({ height: 0, display: 'none' })),
      transition('up => down', animate('300ms')),
      transition('down => up', animate('300ms'))
    ])
  ]
})

export class MenuAccordionGroupComponent extends ContainerBase implements OnChanges {
  private _isOpen = false
  @Input() id: string;
  @Input() ids: string[]

  @Input() heading: string;
  @Input() link: string;

  @Input() disabled: string;

  @Input() activeChain: string[] = []
  @Input() hasChildren = false
  @Input() type = 'default'

  @Input()
  set isOpen(value: boolean) {
    if (this.disabled)
      return;
    this._isOpen = value;
    this._cdr.detectChanges();
  }

  get isOpen() {
    return this._isOpen;
  }

  constructor(@Host() @Inject(forwardRef(() => MenuAccordionComponent)) public accordion: MenuAccordionComponent,
              private _cdr: ChangeDetectorRef,
              private router: Router,
              private store: Store<fromCatalog.State>) {
    super()
  }

  toggle() {
    if (this.disabled)
      return;

    this.isOpen = !this.isOpen;
  }

  onToggleClick(event: MouseEvent) {
    event.stopPropagation()

    this.store.dispatch(new product.SetProductDefaultSortOrder())

    this.toggle();
  }

  navigateTo(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();

  this.router.navigateByUrl(`/${this.link}`)
  }

  setInactive() {
    this.isOpen = false
  }

  ngOnChanges(changes: SimpleChanges) {
    if (Array.isArray(chaining(changes, 'activeChain.currentValue'))) {
      this.isOpen = _.includes(chaining(changes, 'activeChain.currentValue'), this.id)
    }
  }
}
